import React from 'react';

export function Mexico(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H171V342H0V0Z" fill="#006847"/>
      <path d="M171 0H342V342H171V0Z" fill="white"/>
      <path d="M342 0H513V342H342V0Z" fill="#CE1126"/>
      <circle cx="256.5" cy="171" r="30" fill="none" stroke="#8B6914" strokeWidth="3"/>
      <ellipse cx="256.5" cy="171" rx="14" ry="20" fill="#4CAF50"/>
    </svg>
  );
}
